const routerRoutes = [
  {
    path: '/',
    component: require('./Home').default,
    name: 'home',
    meta: { }
  }
]
module.exports = { routerRoutes }



// WEBPACK FOOTER //
// ./src/routes.js